<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 故障记录
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <!-- <el-button
                    type="primary"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
                >高级搜索</el-button>-->
                <!-- <el-select v-model="query.address" placeholder="地址" class="handle-select mr10">
                    <el-option key="1" label="广东省" value="广东省"></el-option>
                    <el-option key="2" label="湖南省" value="湖南省"></el-option>
                </el-select>-->
                <el-input v-model="query.name" placeholder="请输入IMEI" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">刷新</el-button>
                <el-button type="primary" icon="el-icon-search" @click="exportExcel">导出记录</el-button>
            </div>
            <el-table
                :data="tableDatas"
                border
                id="outExcel"
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="id" label="ID" width="150" align="center"></el-table-column>
                <el-table-column prop="IMEI" label="IMEI" width="180"></el-table-column>
                <!-- <el-table-column label="历史故障" width="90" align="center">
                    <template slot-scope="scope">查看</template>
                </el-table-column> -->
                <!-- <el-table-column prop="day" label="当日故障"></el-table-column>
                <el-table-column prop="days" label="总故障"></el-table-column>-->
                <el-table-column prop="deviceType" label="设备类型" width="120"></el-table-column>
                <el-table-column prop="address" label="安装点位" ></el-table-column>
                <!-- <el-table-column prop="cause" label="报警原因"></el-table-column>
                <el-table-column prop="cofim" label="确认类型"></el-table-column> -->
                <el-table-column prop="failDate" align="center" label="故障时间" width="180"></el-table-column>
                <!-- <el-table-column label="账户余额">
                    <template slot-scope="scope">￥{{scope.row.money}}</template>
                </el-table-column>
                <el-table-column label="头像(查看大图)" align="center">
                    <template slot-scope="scope">
                        <el-image
                            class="table-td-thumb"
                            :src="scope.row.thumb"
                            :preview-src-list="[scope.row.thumb]"
                        ></el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="address" label="地址"></el-table-column>
                <el-table-column label="状态" align="center">
                    <template slot-scope="scope">
                        <el-tag
                            :type="scope.row.state==='成功'?'success':(scope.row.state==='失败'?'danger':'')"
                        >{{scope.row.state}}</el-tag>
                    </template>
                </el-table-column>

                <el-table-column prop="date" label="注册时间"></el-table-column>-->
                <el-table-column label="操作" width="90" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
                        >处理</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog title="处理故障" :visible.sync="editVisible" width="30%">
            <el-form ref="form" :model="form" label-width="70px">
                <el-form-item label="确认类型">
                    <el-select
                        v-model="cofimTypeValue"
                        placeholder="请选择"
                        @change="confimSelectChange"
                    >
                        <el-option
                            v-for="item in cofimTypeOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="指派人员" v-if="confimPeopleShow">
                    <el-select v-model="cofimPeopleValue" placeholder="请选择">
                        <el-option
                            v-for="item in cofimPeopleOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="地址">
                    <el-input v-model="form.address"></el-input>
                </el-form-item>-->
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { fetchData } from '../../api/index';
export default {
    name: 'basetable',
    data() {
        return {
            confimPeopleShow: false,
            cofimTypeOptions: [
                {
                    value: '1',
                    label: '故障'
                },
                {
                    value: '2',
                    label: '测试'
                },
                {
                    value: '3',
                    label: '误报'
                },
                {
                    value: '4',
                    label: '演练'
                }
            ],
            cofimPeopleOptions: [
                {
                    value: '1',
                    label: '小王'
                },
                {
                    value: '2',
                    label: '小小王'
                },
                {
                    value: '3',
                    label: '小小小王'
                }
            ],
            cofimTypeValue: '',
            cofimPeopleValue: '',
            tableDatas: [],
            query: {
                address: '',
                name: '',
                pageIndex: 1,
                pageSize: 10
            },
            // tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1
        };
    },
    activated(){
         this.getDataNow();
        this.getPeoples();
    },
    created() {
        this.getDataNow();
        this.getPeoples();
        // this.getData();
    },
    methods: {
         // 导出表格
        exportExcel() {
            console.log('打印');
            this.outToExcels.exportExcel(`${new Date().getTime()}故障记录.xlsx`, '#outExcel');
        }, 
        // 获取当前设备故障信息
        getDataNow() {
            let deviceArr = [];
            this.$store.state.deviceNowData.forEach(item => {
                if (item.status == '故障') {
                    deviceArr.push(item);
                }
            });
            let messageArr = [];
            this.$store.state.deviceMessage.forEach(item => {
                if (item.type == 'troule' && item.status == 0) {
                    messageArr.push(item);
                }
            });
            console.log(deviceArr);
            console.log(messageArr);

            let newArr = [];
            // 根据设备id查询message;
            deviceArr.forEach((item, index) => {
                messageArr.forEach((i, ind) => {
                    if (item.id == i.id) {
                        let obj = item;
                        obj.failDate = i.failDate;
                        obj.messageId = i.messageId;
                        newArr.push(obj);
                    }
                });
            });
            this.tableDatas = newArr;
            this.pageTotal = newArr.length;
            console.log(newArr);
        },

        // 监听派单选择器变化
        confimSelectChange(e) {
            console.log(e);
            if (e == 1 || e == 4) {
                this.confimPeopleShow = true;
            } else {
                this.confimPeopleShow = false;
                this.cofimPeopleValue = '';
            }
        },

        // 获取人员信息
        getPeoples() {
            let arr = this.$store.state.peoples.map(item => {
                item.value = item.id;
                item.label = item.name;
                return item;
            });
            let newArr = [];
            arr.forEach(item => {
                if (item.role == 3) {
                    newArr.push(item);
                }
            });
            this.cofimPeopleOptions = newArr;
            //  {
            //         value: '1',
            //         label: '小王'
            //     }
        },

        // 确认指派
        saveEdit(e) {
            if (this.cofimTypeValue.trim() == '') {
                this.$message.error('未选择类型');
            } else if (this.cofimTypeValue != 1 && this.cofimTypeValue != 4) {
                console.log('this.form');
                console.log(this.form);

                // 测试或者误报  直接修改设备属性状态为正常并处理工单信息
                this.$store.commit('setDeviceNormalOne', this.form.id);
                this.$store.commit('setMessageSuccessOne', this.form.messageId);
                console.log(this.$store.state.deviceMessage);
                // 重新获取数据
                this.getDataNow();
                this.$message.success('处理完成');
                this.editVisible = false;
            } else {
                if (this.cofimPeopleValue == '') {
                    this.$message.error('未选择人员');
                } else {
                    console.log('选择了人员');
                    // 测试或者误报  直接修改设备属性状态为正常并处理工单信息
                this.$store.commit('setDeviceNormalOne', this.form.id);
                this.$store.commit('setMessageSuccessOne', this.form.messageId);
                console.log(this.$store.state.deviceMessage);
                // 重新获取数据
                this.getDataNow();
                this.$message.success('处理完成');
                this.editVisible = false;
                }
            }
        },

        // 获取 easy-mock 的模拟数据
        // getData() {
        //     fetchData(this.query).then((res) => {
        //         console.log(res);
        //         this.tableData = res.list;
        //         this.pageTotal = res.pageTotal || 50;
        //     });
        // },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    this.$message.success('删除成功');
                    this.tableData.splice(index, 1);
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].name + ' ';
            }
            this.$message.error(`删除了${str}`);
            this.multipleSelection = [];
        },
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
            this.form = row;
            this.editVisible = true;
        },
        // 保存编辑
        // saveEdit() {
        //     this.editVisible = false;
        //     this.$message.success(`已处理`);
        //     this.$set(this.tableData, this.idx, this.form);
        // },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
